<template>
  <div class="b-vehicle-compare-card">
    <div class="mb-12">
      <LazyImage
        :image="image"
        :title="dictionary.buttonVehicleViewMoreText"
        class="cursor-pointer"
        @click="onClickButton" />
    </div>
    <div class="h4 extrabold mb-5">
      {{ item.manufacturer }} {{ item.short_model_name }}
    </div>
    <div class="semibold mb-8">{{ modelNameComputed }}</div>
    <div class="h4 extrabold mb-24">
      €{{ priceFormatted }} {{ dictionary.vehiclePriceSuffix }}
    </div>
    <button
      type="button"
      class="btn btn-primary btn-full-width"
      @click="onClickButton">
      {{ dictionary.buttonVehicleViewMoreText }}
    </button>
  </div>
</template>

<script>
import * as lib from './../../../lib/lib'
import LazyImage from './../common/LazyImage.vue'

export default {
  components: { LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      lang: 'en',
    }
  },
  computed: {
    priceFormatted() {
      return this.item.initial_rental_price.toLocaleString(this.lang)
    },

    modelNameComputed() {
      if (!this.item) {
        return null
      }
      /* eslint-disable camelcase */
      const { model_name, short_model_name } = this.item
      const modelName = model_name.replace(short_model_name, '')

      return `${modelName} ${this.item.model_key}`
    },

    image() {
      const images = this.item.slider_images
      if (!images.length) {
        return null
      }
      return {
        url: images[0],
        alt: '',
      }
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
  },
  methods: {
    onClickButton() {
      /* eslint-disable camelcase */
      const { language } = this.$route.params
      const { slug, vehicle_id } = this.item
      this.$router.push({
        name: 'car',
        params: { language, slug, id: vehicle_id },
      })
      lib.scrollToTop()
    },
  },
}
</script>
